"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SqlDatasource = void 0;
const tslib_1 = require("tslib");
/**
 * A library containing the different design components of the Grafana plugins ecosystem.
 *
 * @packageDocumentation
 */
tslib_1.__exportStar(require("./components"), exports);
var SqlDatasource_1 = require("./datasource/SqlDatasource");
Object.defineProperty(exports, "SqlDatasource", { enumerable: true, get: function () { return SqlDatasource_1.SqlDatasource; } });
//# sourceMappingURL=index.js.map